import { DialogContentText, DialogTitle, useTheme } from "@mui/material";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { sizing } from "ds_legacy/materials/metrics";
import { Halo } from "dsl/atoms/Halo";
import { NUDGE_LOCALSTORAGE_KEY } from "dsl/atoms/HintNudge";
import { ProviderSearchModalActions } from "dsl/ecosystems/ProviderSearchAssessmentModal/shared";
import {
  DialogContentWrapper,
  MODAL_MIN_WIDTH,
  ProviderSearchDialog,
} from "dsl/ecosystems/ProviderSearchLoginModal/shared";
import { useProvidersearchNavigationHandlers } from "dsl/hooks/useNavigationHandlers";
import { LogOutIcon } from "lucide-react";
import { useOnLogout } from "reduxentities/hooks";
import { useTranslations } from "translations";

const useOnLogoutProviderSearch = ({
  onComplete,
}: {
  onComplete: () => void;
}) => {
  const { goToOnboardingFunnel } = useProvidersearchNavigationHandlers();
  const onLogout = useOnLogout();

  return () => {
    goToOnboardingFunnel();

    const nudgeValue = window.localStorage.getItem(NUDGE_LOCALSTORAGE_KEY);

    onLogout({ hardRefresh: true });

    if (nudgeValue) {
      window.localStorage.setItem(NUDGE_LOCALSTORAGE_KEY, nudgeValue);
    }

    onComplete();
  };
};

export const ConfirmLogoutDialog = ({ onClose }: { onClose: () => void }) => {
  const translations = useTranslations();
  const theme = useTheme();
  const onLogout = useOnLogoutProviderSearch({ onComplete: onClose });

  return (
    <ProviderSearchDialog
      paperStyle={{ maxWidth: MODAL_MIN_WIDTH, width: "100%" }}
      style={{ display: "flex", justifyContent: "center" }}
      onClose={onClose}
    >
      <DialogContentWrapper testId="logout-conformation">
        <HorizontalLayout justify="center" width="100%">
          <Halo
            backgroundColor={theme.palette.error.light}
            padding={sizing(1.5)}
          >
            <LogOutIcon
              size={20}
              style={{ color: theme.palette.neutrals.base_dark }}
            />
          </Halo>
        </HorizontalLayout>
        <DialogTitle sx={{ wordBreak: "break-word" }} textAlign="center">
          {translations.providersearch.logoutModal.title}
        </DialogTitle>
        <DialogContentText textAlign="center">
          {translations.providersearch.logoutModal.subtitle}
        </DialogContentText>
      </DialogContentWrapper>
      <ProviderSearchModalActions
        cancelProps={{ id: "cancel" }}
        cancelText={translations.providersearch.logoutModal.buttonCancel}
        submitProps={{ id: "confirm" }}
        submitText={translations.providersearch.logoutModal.buttonLogout}
        onCancel={onClose}
        onSubmit={onLogout}
      />
    </ProviderSearchDialog>
  );
};
